var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #337fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.26,26.12h-4.29l-1.96-.65-1.95.65h-4.32c-3.54,0-6.42-2.87-6.42-6.42V7.19C.32,3.65,3.2.77,6.74.77h12.52c3.54,0,6.42,2.87,6.42,6.42v12.52c0,3.54-2.87,6.42-6.42,6.42Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m11.04,10.69v2.76h-3.18v3.62h3.18v9.05h3.91v-9.05h2.92l.56-3.62h-3.47v-2.35c0-.99.48-1.95,2.04-1.95h1.58v-3.08s-1.43-.25-2.8-.25c-2.86,0-4.73,1.74-4.73,4.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9e9a3e7a29afc88a4d6797e6d0519484.svg";
export { ForwardRef as ReactComponent };